import { Suspense } from 'react'

import { MainLogo } from 'components/MainLogo/MainLogo'

import { KnowledgeBasePageAsync } from './KnowledgeBasePage.async'

export const LazyKnowledgeBasePage = () => (
  <Suspense fallback={<MainLogo />}>
    <KnowledgeBasePageAsync />
  </Suspense>
)
